import Swiper, { FreeMode } from 'swiper'
Swiper.use([FreeMode])

import { select } from '@js/util/select.js'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus.js'

select('.wpce-slider', sliderElement => {
  const swiperElement = sliderElement.querySelector('.swiper')
  const swiper = new Swiper(swiperElement, {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 25,
    distance: 5,
    centeredSlides: false,

    // If we need pagination
    pagination: false,
    ...(sliderElement.dataset.swiperOptions ? JSON.parse(sliderElement.dataset.swiperOptions) : {}),
  })

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  // Handle previous button
  function onPrevClick() {
    swiper.slideTo(swiper.activeIndex - 1)
  }
  const prevButton = sliderElement.querySelector('.custom-button-prev')
  prevButton?.addEventListener('click', onPrevClick)

  // Handle next button
  function onNextClick() {
    swiper.slideTo(swiper.activeIndex + 1)
  }
  const nextButton = sliderElement.querySelector('.custom-button-next')
  nextButton?.addEventListener('click', onNextClick)

  const updateButtons = () => {
    prevButton.disabled = swiper.isBeginning
    nextButton.disabled = swiper.isEnd
  }

  updateButtons()
  swiper.on('slideChange', updateButtons)
  swiper.on('reachBeginning', updateButtons)
  swiper.on('reachEnd', updateButtons)
  swiper.on('resize', updateButtons)

  // Handle button wrapper
  const buttonWrapper = sliderElement.querySelector('.button-wrapper')
  const updateLockSideEffectsWrapper = () => {
    sliderElement.classList.toggle('is-active', !swiper.isLocked)
    buttonWrapper.classList.toggle('is-hidden', swiper.isLocked)
  }

  updateLockSideEffectsWrapper()
  swiper.on('lock', updateLockSideEffectsWrapper)
  swiper.on('unlock', updateLockSideEffectsWrapper)

  // Handle swiper destroy
  swiper.once('beforeDestroy', () => {
    prevButton?.removeEventListener('click', onPrevClick)
    nextButton?.removeEventListener('click', onNextClick)
  })

  return () => {
    swiper.destroy()
  }
})
